// Display cache only: never use these fields as order ownership or authority.
// Follow the existing header priority and the server's linked-order ordering.
export function getConversationOrderId(conversation) {
  const attrs = conversation?.custom_attributes ?? conversation?.customAttributes ?? {};
  const primary = attrs.amazon_order_id ?? attrs.amazonOrderId;
  const orders = attrs.amazon_order_ids ?? attrs.amazonOrderIds;
  const linked = attrs.borderchat_linked_order_ids ?? attrs.borderchatLinkedOrderIds;
  const candidates = [
    primary,
    ...(Array.isArray(orders) ? orders : [orders]),
    ...(Array.isArray(linked) ? linked : []),
  ];
  return candidates.find(value => typeof value === 'string' && value.trim())?.trim() || '';
}
